var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ModuleValueGeneral, SchemaModuleGeneral } from './module-general';
import * as rawJSONSchemaModuleCancerOvarian from '../../schemas/module-cancer-ovarian.json';
var ModuleValueCancerOvarian = (function (_super) {
    __extends(ModuleValueCancerOvarian, _super);
    function ModuleValueCancerOvarian() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ModuleValueCancerOvarian;
}(ModuleValueGeneral));
var SchemaModuleCancerOvarian = (function (_super) {
    __extends(SchemaModuleCancerOvarian, _super);
    function SchemaModuleCancerOvarian() {
        var _this = _super.call(this) || this;
        _this.loadSchema(rawJSONSchemaModuleCancerOvarian);
        return _this;
    }
    SchemaModuleCancerOvarian.prototype.hook = function (form) {
        _super.prototype.hook.call(this, form);
        this.listenValue(['recurrence_progression_date', 'main_procedure', 'date_of_surgery', 'start_date_neoadjuvant'], this.fieldHandlerCalculateProgressionFreeSurvival.bind(this));
        this.listenValue(['date_last_follow_up', 'main_procedure', 'date_of_surgery', 'start_date_neoadjuvant'], this.fieldHandlerCalculateFollowUpDuration.bind(this));
        this.listenValue('follow_up_duration_compute', this.fieldHandlerFollowUpDurationCompute.bind(this));
        this.listenValue(['date_last_follow_up', 'main_procedure', 'date_of_surgery', 'start_date_neoadjuvant'], this.fieldHandlerCalculateSurvival.bind(this));
    };
    SchemaModuleCancerOvarian.prototype.setupValidators = function () {
        _super.prototype.setupValidators.call(this);
        this.validatorDateComparison('date_of_birth', 'date_of_diagnosis', '<');
        this.validatorDateComparison('date_of_diagnosis', 'date_of_surgery', '<=');
        this.validatorDateComparison('date_of_diagnosis', 'date_last_follow_up', '<');
        this.validatorDateComparison('date_of_diagnosis', 'recurrence_progression_date', '<=');
        this.validatorDate('date_of_birth', (new Date()), '<=', function (v) { return new Date(v); });
        this.validatorDate('date_of_diagnosis', (new Date()), '<=', function (v) { return new Date(v); });
    };
    SchemaModuleCancerOvarian.prototype.fieldHandlerCalculateProgressionFreeSurvival = function (recurrenceDate, mainProcedure, surgeryDate, neoadjuvantStartDate) {
        var startDate = this.resolveStartDate(mainProcedure, surgeryDate, neoadjuvantStartDate);
        this.updateValue('progression_free_survival_duration', this.diffInMonths(recurrenceDate, startDate, 30.25));
    };
    SchemaModuleCancerOvarian.prototype.fieldHandlerCalculateFollowUpDuration = function (followUpDate, mainProcedure, surgeryDate, neoadjuvantStartDate) {
        if (!this.getValue('follow_up_duration_compute'))
            return;
        var startDate = this.resolveStartDate(mainProcedure, surgeryDate, neoadjuvantStartDate);
        this.updateValue('follow_up_duration', this.diffInMonths(followUpDate, startDate, 30.5));
    };
    SchemaModuleCancerOvarian.prototype.fieldHandlerFollowUpDurationCompute = function (compute) {
        if (typeof compute === 'undefined' || compute === null)
            return;
        this.schema.properties['follow_up_duration'].readOnly = compute;
        if (compute) {
            this.fieldHandlerCalculateFollowUpDuration(this.getValue('date_last_follow_up'), this.getValue('main_procedure'), this.getValue('date_of_surgery'), this.getValue('start_date_neoadjuvant'));
        }
    };
    SchemaModuleCancerOvarian.prototype.fieldHandlerCalculateSurvival = function (followUpDate, mainProcedure, surgeryDate, neoadjuvantStartDate) {
        var startDate = this.resolveStartDate(mainProcedure, surgeryDate, neoadjuvantStartDate);
        this.updateValue('survival', this.diffInMonths(followUpDate, startDate, 30.5));
    };
    SchemaModuleCancerOvarian.prototype.resolveStartDate = function (mainProcedure, surgeryDate, neoadjuvantStartDate) {
        if (mainProcedure === 'neoadjuvant_chemotherapy')
            return neoadjuvantStartDate;
        return surgeryDate;
    };
    return SchemaModuleCancerOvarian;
}(SchemaModuleGeneral));
export { SchemaModuleCancerOvarian };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/module-cancer-ovarian.ts.pre-build-optimizer.js